import { Provider } from 'react-redux';

import { Container } from './Container';
import { useDQIDEStore } from './redux/store';

export function ObservationContainer() {
  const store = useDQIDEStore();

  return (
    <Provider store={store}>
      <Container />
    </Provider>
  );
}
